var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_718_13519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22051 4.20443L9.34151 6.32593L4.39151 11.2754H2.27051V9.15393L7.22051 4.20393V4.20443ZM7.92751 3.49743L8.98801 2.43643C9.08177 2.3427 9.20893 2.29004 9.34151 2.29004C9.47409 2.29004 9.60124 2.3427 9.69501 2.43643L11.1095 3.85093C11.2032 3.9447 11.2559 4.07185 11.2559 4.20443C11.2559 4.33701 11.2032 4.46417 11.1095 4.55793L10.0485 5.61843L7.92751 3.49743Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_718_13519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.770508 0.775391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit_dark.8607e06d716d7936e0883504941003a7.svg";
export { ForwardRef as ReactComponent };